<template>
  <div class="select-student">
    <div class="console">
      <div class="flex-right">
        <h4 class="flex-right-flex1" style="margin: 0">选择学生</h4>
        <Button size="small" type="dashed" @click="insertNew">新建</Button>
      </div>
      <Input
        search
        placeholder="输入届数或姓名查找..."
        clearable
        v-model="word"
        @on-search="selectByAdmin(false)"
        @on-clear="selectByAdmin(false)"
      />
    </div>

    <Menu
      class="select-student-container"
      ref="menu"
      theme="light"
      :active-name="selectedItem"
      @on-select="change"
    >
      <MenuItem v-for="item in data.list" :key="item._id" :name="item._id">
        {{ item.sesstion }} - {{ item.name }}
      </MenuItem>
    </Menu>

    <div class="flex-mid">
      <Page
        :current="data.page"
        :total="data.total"
        :page-size="data.size"
        simple
        @on-change="select"
      />
    </div>

    <div class="new-student" v-if="$route.query.isEditingNewStudent">
      <h3>正在编辑新学生</h3>
      <Button size="small" type="dashed" @click="cancelInsertNew"
        >取消编辑</Button
      >
    </div>
  </div>
</template>

<script>
import bus from "@/bus.js";
export default {
  data() {
    return {
      data: {},
      selectedItem: "",
      word: "",
    };
  },
  methods: {
    async select(page = 1) {
      let res = await this.api({
        url: "/student/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          page: page,
          size: 10,
          word: this.word,
        },
      });

      // if (page > 1) {
      //   res.list = this.data.list.concat(res.list);
      // }

      this.data = res;
      this.change(res.list[0]._id);
    },

    change(_id) {
      this.selectedItem = _id;
      this.$nextTick(() => {
        this.$refs["menu"].updateActiveName();
      });
      let selectedStudent;
      this.data.list.forEach((item) => {
        if (_id == item._id) {
          selectedStudent = item;
        }
      });
      this.$store.dispatch("changeSelectStudent", selectedStudent);
      this.$Message.success("切换学生");
      if (this.$route.path == "/home" || this.$route.path == "/login/success") {
        this.$router.push({
          path: "/planning/planning_general_view",
        });
      }
    },

    insertNew() {
      this.$router.push({
        path: "/student",
        query: {
          isEditingNewStudent: true,
        },
      });
      this.$store.dispatch("changeSelectStudent", {});
    },

    cancelInsertNew() {
      this.$router.push({
        path: "/student",
      });
      this.$store.dispatch("changeSelectStudent", this.data.list[0]);
    },
  },
  mounted() {
    this.select();
    bus.$on("reloadStudentList", () => {
      this.select();
    });
    bus.$on("changeSelectedStudent", (student_id) => {
      this.change(student_id);
    });
  },
};
</script>

<style lang="less">
.select-student {
  position: relative;
  .console {
    h4 {
      font-size: 16px;
      margin: 0 auto 10px;
      font-weight: bolder;
      text-align: center;
    }
    padding: 20px 20px;
  }
}
.select-student-container {
  min-height: 500px;

  .ivu-menu-item-active {
    color: #ffffff !important;
    background: #6d87ff!important;
    z-index: 2!important;
  }
}
.flex-mid {
  display: flex;
  align-items: center;
  justify-content: center;
}
.new-student {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(256, 256, 256, 1);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h3 {
    font-size: 16px;
    margin: 0 auto 10px;
    font-weight: bolder;
    text-align: center;
  }
}
</style>